import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isEanNumber: ValidatorFn = Validators.pattern(`^[0-9]{13}$`);

export const eanNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = '^[0-9]{13}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { eanNumber: true };
};

export const isUniqueEanNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  return (control.parent?.parent as UntypedFormArray)?.controls.filter(
    (eanGroup) => {
      return (
        (eanGroup as UntypedFormGroup).controls['ean'].value == control.value
      );
    }
  ).length > 1
    ? { eanNumberDuplicate: true }
    : null;
};
